import React from 'react';

interface AvatarProps {
  url?: string;
  fallback?: string;
  size?: string;
}

export const Avatar = (props: AvatarProps) => {
  const { url, fallback } = props;
  const size = props.size || '2.5rem';
  return (
    <span className="avatar inline-block">
      {
        url ?
          <img className="rounded-full" src={url} alt={fallback || ''} style={{ width: size, height: size }} />
          :
          <div className="placeholder flex flex-col justify-around rounded-full bg-primary text-center font-bold text-on-primary!" style={{ width: size, height: size }}>{fallback}</div>
      }
    </span>
  );
};
